import { render } from "./QualificationSkill.vue?vue&type=template&id=35b43866"
import script from "./QualificationSkill.vue?vue&type=script&lang=js"
export * from "./QualificationSkill.vue?vue&type=script&lang=js"

import exportComponent from "/Users/soil2sons/Projects/Work/Ensibuuko/hrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__